<!-- Date-range inputs (filename + needs-attention now live in the toolbar) -->
<div class="flex flex-wrap gap-3">
  <div class="flex-1 min-w-44">
    <label for="ocrFiltersStartDate" class="block text-xs font-medium text-ds-text-muted mb-1">Start</label>
    <input id="ocrFiltersStartDate" data-testid="ocr-filters-start-date-input" type="datetime-local"
           class="w-full h-8 px-2 text-sm font-data border border-ds-border rounded-ds-sm bg-ds-bg text-ds-text transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-ds-secondary focus:border-ds-secondary"
           [value]="filters().startDate || ''"
           (change)="filters().startDate=$any($event.target).value || null; onFiltersChanged()" />
  </div>
  <div class="flex-1 min-w-44">
    <label for="ocrFiltersEndDate" class="block text-xs font-medium text-ds-text-muted mb-1">End</label>
    <input id="ocrFiltersEndDate" data-testid="ocr-filters-end-date-input" type="datetime-local"
           class="w-full h-8 px-2 text-sm font-data border border-ds-border rounded-ds-sm bg-ds-bg text-ds-text transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-ds-secondary focus:border-ds-secondary"
           [value]="filters().endDate || ''"
           (change)="filters().endDate=$any($event.target).value || null; onFiltersChanged()" />
  </div>
</div>
